import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../utils/api';

// Query Keys
export const dashboardQueryKeys = {
  all: ['dashboard'],
  cardPositions: (userSysId) => [...dashboardQueryKeys.all, 'cardPositions', userSysId],
};

/**
 * 사용자별 설정된 대시보드 카드 위젯 목록 조회
 * @param {string} userSysId - 사용자 시스템 ID
 */
export const useDashboardCardPositions = (userSysId, options = {}) => {
  return useQuery({
    queryKey: dashboardQueryKeys.cardPositions(userSysId),
    queryFn: async () => {
      if (!userSysId) return null;
      const response = await api.get(`/drivecore/id/api/DashBoardCustom/${userSysId}`);
      return response;
    },
    enabled: !!userSysId && options.enabled !== false,
    staleTime: 5 * 60 * 1000, // 5분
    cacheTime: 10 * 60 * 1000, // 10분
    ...options,
  });
};

/**
 * 카드 위치 정보 저장 (전체 대체)
 * @returns {Object} mutation 객체
 */
export const useSaveDashboardCardPositions = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload) => {
      const response = await api.post('/drivecore/id/api/DashBoardCustom', payload);
      return response;
    },
    onSuccess: (data, variables) => {
      // 저장 성공 시 해당 사용자의 카드 위치 정보 캐시 무효화
      const userSysId = variables?.userSysId;
      if (userSysId) {
        queryClient.invalidateQueries({
          queryKey: dashboardQueryKeys.cardPositions(userSysId),
        });
      }
    },
  });
};

